import React, { useEffect, useState } from "react";
import AccessPointWizard from "../../components/react-componnets/components/wizardAccessPoints/index";
import { ACCESS_POINT_DATA } from "../../components/react-componnets/utilities/constants";
import { fetchACUById, fetchAPList, fetchAPListIMAG, fetchAPTemplateList } from "../../components/react-componnets/api/APWizardService";
import LoadingSpinner from "../../components/react-componnets/components/loading";

const APWizard = ({ wizardStep, changeWizardPage, selectedACU, handleCloseModal, handleNotification, saveAccessPoint }) => {
  const [ApTypes, setApTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [templateData, setTemplateData] = useState(null);
  const [fieldsData, setFieldsData] = useState(null);
  const [componentSourceOptions, setComponentSourceOptions] = useState(null);
  const [prevAccessPoints, setPrevAccessPoints] = useState([]);
  const [defaultSelectedPortsState, setDefaultSelectedPortsState] = useState({
    input: {},
    output: {},
    readers: {},
  });

  useEffect(() => {
    if (wizardStep === '2' && selectedACU?.model) {
      setLoading(true);
      (async () => {
        const data = await fetchAPListIMAG();
        const res = await fetchAPTemplateList(selectedACU?.model);
        const acuDATA = await fetchACUById(selectedACU?.id, selectedACU?.model);
        setPrevAccessPoints(acuDATA.access_points)
        handleAccessPointsSelectedPores(acuDATA.access_points)
        setFieldsData(acuDATA.accessPointData)
        setComponentSourceOptions(acuDATA.acuData)
        setTemplateData(res);
        setApTypes(data);
        setLoading(false);

      })()
    }
  }, []);

  const handleAccessPointsSelectedPores = (prevAccessPoints) => {
    let testState = {
      input: {},
      output: {},
      readers: {},
    }
    for (let i = 0; i < prevAccessPoints.length; i++) {
      testState = handelSetSelectedPorts(prevAccessPoints[i], testState)
    }
    setDefaultSelectedPortsState(testState)
  }



  const handelSetSelectedPorts = (data, state) => {

    const result = state;
    if (!data) {
      setSelectedPorts(result)
      return 0
    }
    for (let item of data.readers) {
      if (result.readers[item.component_source]) {
        result.readers[item.component_source] = {
          ...result.readers[item.component_source],
          [item.port]: true,
        }
      } else {
        result.readers[item.component_source] = {
          [item.port]: true,
        }
      }
    }

    const resources =
      typeof data.resources == "string"
        ? JSON.parse(data.resources)
        : data.resources;

    for (const key in resources) {
      if (resources[key].input) {
        if (result.input[resources[key].component_source]) {
          result.input[resources[key].component_source] = {
            ...result.input[resources[key].component_source],
            [resources[key].input]: true
          }
        } else {
          result.input[resources[key].component_source] = {
            [resources[key].input]: true
          }
        }

      } else {
        if (result.output[resources[key].component_source]) {
          result.output[resources[key].component_source] = {
            ...result.output[resources[key].component_source],
            [resources[key].output]: true
          }
        } else {
          result.output[resources[key].component_source] = {
            [resources[key].output]: true
          }
        }
      }

    }
    return result
  };

  return (
    <div>
      {
        loading ? <LoadingSpinner /> :
          <AccessPointWizard
            ACUModel={selectedACU?.model}
            prevAccessPoints={defaultSelectedPortsState}
            acuId={selectedACU?.id}
            handleSaveAccessPoint={(data) => {
              saveAccessPoint(data)
            }}
            handleNotification={handleNotification}
            handleCloseModal={handleCloseModal}
            fieldsData={fieldsData}
            templateData={templateData}
            wizardStep={wizardStep}
            changeWizardPage={changeWizardPage}
            componentSourceOptions={componentSourceOptions}
            data={ApTypes} closeACUModal={(e) => { console.log(e, "closeACUModal") }}
            showNotificationPopUp={(e) => { console.log(e, "show notification ") }}
          />
      }
    </div>
  );
};

export default APWizard;
